import { render, staticRenderFns } from "./video-hls.vue?vue&type=template&id=36d160dc"
import script from "./video-hls.vue?vue&type=script&lang=js"
export * from "./video-hls.vue?vue&type=script&lang=js"
import style0 from "./video-hls.vue?vue&type=style&index=0&id=36d160dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports